var _a, _b;
import products from "../enums/products";
export var SET_PACKAGE = "SET_PACKAGE";
export var SET_MEDICAL_TIER = "SET_MEDICAL_TIER";
export var DEAL_TAGS_BLACKLIST = "blacklistTagIds";
export var DEAL_DEALS_BLACKLIST = "blacklistDealIds";
export var DEALS = products.deals;
export var RECOGNITION = products.recognition;
export var INSIGHTS = products.insights;
export var MEDICAL = products.medical;
export var TENANT_WALLET = products.tenantWallet;
export var USER_WALLET = products.userWallet;
export var REPORTINGV3 = products.reportingV3;
export var SSO_OPTIONS = products.ssoOptions;
export var TENANT_ONBOARDING = products.tenantOnboarding;
export var CULTURE_HUB = products.cultureHub;
export var ENABLE = (_a = {},
    _a[DEALS] = "ENABLE_PRODUCT_DEALS",
    _a[RECOGNITION] = "ENABLE_PRODUCT_RECOGNITION",
    _a[INSIGHTS] = "ENABLE_PRODUCT_INSIGHTS",
    _a[MEDICAL] = "ENABLE_PRODUCT_MEDICAL",
    _a[TENANT_WALLET] = "ENABLE_PRODUCT_TENANT_WALLET",
    _a[USER_WALLET] = "ENABLE_PRODUCT_USER_WALLET",
    _a[CULTURE_HUB] = "ENABLE_PRODUCT_CULTURE_HUB",
    _a);
export var DISABLE = (_b = {},
    _b[DEALS] = "DISABLE_PRODUCT_DEALS",
    _b[RECOGNITION] = "DISABLE_PRODUCT_RECOGNITION",
    _b[INSIGHTS] = "DISABLE_PRODUCT_INSIGHTS",
    _b[MEDICAL] = "DISABLE_PRODUCT_MEDICAL",
    _b[TENANT_WALLET] = "DISABLE_PRODUCT_TENANT_WALLET",
    _b[USER_WALLET] = "DISABLE_PRODUCT_USER_WALLET",
    _b[CULTURE_HUB] = "DISABLE_PRODUCT_CULTURE_HUB",
    _b);
